import { FINISH } from 'actiontypes/storylet';

/** ----------------------------------------------------------------------------
 * FINISH
 -----------------------------------------------------------------------------*/
export default function finish() {
  return async dispatch => dispatch(finishStorylet());
}

export const finishStorylet = () => ({ type: FINISH });